import React from 'react'
import { FormControl, Button, Row, Col, ControlLabel } from 'react-bootstrap'
import TransactionDetails from './TransactionDetails'
import axios from 'axios'
import { end_point, getParams, makeUniqueKey } from './helper'
import PricingDetails from './PricingDetails'
import moment from 'moment'

const statusSelections = [
  { value: 'unverified', label: 'Unverified' },
  { value: 'unpaid', label: 'Unpaid' },
  { value: 'paid', label: 'Paid - Full' },
  { value: 'paidinstal', label: 'Paid - Instal' },
  { value: 'fullrefund', label: 'Full Refund' },
  { value: 'partialrefund', label: 'Partial Refund' },
  { value: 'waitlist', label: 'Waitlist' }
]

class TransactionUpdate extends React.Component {
  constructor(props) {
    super(props)
    this.state= {
      spinner: false,
      emailSent: false,
      emailConfirmation: null
    }
    console.log('!!! PROPS in TransactionForm',this.props)
  }

  componentDidMount(){
    console.log("props for transaction update", this.props)
  }

  renderSubtotal(plan, shirt, shorts, hood, additional) {
    const { selectedItem } = this.props.tx
    var subTotal = plan + shirt + shorts + hood + additional
    if (selectedItem.price_breakdown.extra_fees) {
      selectedItem.price_breakdown.extra_fees.forEach(fee => {
        for (var extra in fee) {
          subTotal += fee[extra]
        }
      })
    }
    
    return subTotal
  }

  handleUpdateSubmit(item) {
    this.setState({spinner: true})
    var formFields = {
      "status": document.getElementById("status").value,
      "notes": document.getElementById("notes").value,
      "status_update_manual": true,
      "transaction_id": item.selectedItem._id
    }
    console.log("*** FORM FIELDS=",formFields)
    this.props.tx.patchUpdateMethod(formFields, item.selectedItem._id, 'transaction');
  }

  requestEmailResend = async item => {
    var selectedItem = item && item.selectedItem ? item.selectedItem : item
    var recipientEmail = selectedItem && selectedItem.parent && selectedItem.parent.email
      ? selectedItem.parent.email
      : selectedItem && selectedItem.user && selectedItem.user.email
        ? selectedItem.user.email
        : ''

    if (!recipientEmail) {
      var recipientId = selectedItem && selectedItem.parent && selectedItem.parent._id
        ? selectedItem.parent._id
        : selectedItem && selectedItem.user && selectedItem.user._id
          ? selectedItem.user._id
          : null

      if (recipientId) {
        try {
          var usersResponse = await axios.get(`${end_point('users')}/users`, {
            headers: {
              token: getParams().jwt,
              organization_id: localStorage.getItem('organization_id')
            }
          })
          var users = usersResponse.data && usersResponse.data.message ? usersResponse.data.message : []
          var recipient = users.find(user => user._id && user._id.toString() === recipientId.toString())
          recipientEmail = recipient && recipient.email ? recipient.email : ''
        } catch (error) {
          console.log('Unable to resolve receipt recipient email', error)
        }
      }
    }

    this.setState({
      emailConfirmation: {
        item,
        recipientEmail
      }
    })
  }

  sendEnrolNotification = async item => {
    var rthis = this
    this.setState({spinner: true})
    console.log('sending notification', item)
    
    await axios.patch(`${end_point('transactions')}/transactions`, {
      item,
      "resend": true,
      "token": getParams().jwt
    }).then(response => {
      console.log("Back from sending email", response)
      if (response.status === 200) {
        rthis.setState({
          spinner: false,
          emailSent: true,
          emailConfirmation: null
        })
      } else {
        window.alert('Someting went wrong. Please try again')
        rthis.setState({
          spinner: false,
          emailConfirmation: null
        })
      }
    })
  }

  confirmEmailResend = () => {
    if (this.state.emailConfirmation) {
      this.sendEnrolNotification(this.state.emailConfirmation.item)
    }
  }

  cancelEmailResend = () => {
    this.setState({emailConfirmation: null})
  }

  render() {
    const { selectedItem, organization_merch} = this.props.tx
    const paymentGateway = selectedItem.payment_gateway || {}
    var EF3 = selectedItem.programs ? false : true
    var notes = paymentGateway.notes || ""
    var statusOptions = []
    if(!selectedItem.payment_gateway){
      statusOptions.push(<option key="" value="" selected disabled>---</option>)
    }
    statusSelections.forEach(status => {
      let paystatus = paymentGateway.status || (EF3 ? {} : [])
      let tnx_status = EF3
        ? paystatus.status
        : Array.isArray(paystatus) && paystatus.length
          ? paystatus[paystatus.length - 1].status
          : paystatus.status
      
      status.value === tnx_status ? 
        statusOptions.push(<option key={status.value} selected value={status.value}>{status.label}</option>) :
        statusOptions.push(<option key={status.value} value={status.value}>{status.label}</option>)
    })
 
    var historyArray = Array.isArray(paymentGateway.history) ? paymentGateway.history : []
    var emailConfirmation = this.state.emailConfirmation
    return (
      <div className="modal-formfields">
        {emailConfirmation &&
          <div className="transaction-email-confirmation-backdrop">
            <div className="transaction-email-confirmation" role="dialog" aria-modal="true" aria-labelledby="transaction-email-confirmation-title">
              <div className="transaction-email-confirmation-kicker">Send receipt</div>
              <h4 id="transaction-email-confirmation-title">Confirm email delivery</h4>
              <p>The receipt will be sent to:</p>
              <div className="transaction-email-confirmation-address">
                {emailConfirmation.recipientEmail || 'the account holder email on file'}
              </div>
              <div className="transaction-email-confirmation-actions">
                <Button className="button2 transaction-email-confirmation-cancel" onClick={this.cancelEmailResend}>
                  Cancel
                </Button>
                <Button className="button2" bsStyle="primary" onClick={this.confirmEmailResend}>
                  Send receipt
                </Button>
              </div>
            </div>
          </div>
        }
        <Row>
          <Col lg={7} xs={12}>
            <TransactionDetails selectedItem={selectedItem}/>
            <Col sm={12} className="opaque-grey transaction-details">
            {/* <h3>Pricing Details</h3> */}
            <PricingDetails selectedItem={selectedItem} organization_merch={organization_merch} sendEnrolNotification={this.requestEmailResend}/>
            </Col>
          </Col>

          <Col lg={5} sm={4}>
            <Col sm={12} className="opaque-grey transaction-details">

              <ControlLabel>Status</ControlLabel>
              <FormControl className="opaque-grey form-group" componentClass="select" id="status">
                {statusOptions}
              </FormControl>
              <ControlLabel>Notes</ControlLabel>
              <FormControl className="opaque-grey form-group" name="notes" componentClass="textarea" id="notes" defaultValue={notes} rows={5} />

            </Col>

            <Col lg={12} sm={8} className="opaque-grey transaction-details">

              {
                historyArray.map(status => {
                  let date = moment(status.timestamp).format('lll')
                  let tnxStatus = status.status === 'partialrefund' ? 'partial refund' : status.status === 'fullrefund' ? "full refund" : status.status
                  return (
                    <Row className="form-group" key={makeUniqueKey()}>
                      <Col sm={7}>{date}</Col>
                      <Col sm={5} style={{padding: "0"}}>{tnxStatus}</Col>      
                    </Row>
                  )
                })
              }
              
              </Col>

          </Col>
        </Row>

        <Row>
          {
            this.state.spinner ?
              <Col sm={5} className="pull-right">
                <div className="enrolment-loader" style={{margin: 'auto'}}></div>
              </Col>
            :
            this.state.emailSent ?
              <Col sm={4} className="pull-right">
                <Button className="button2" bsStyle="primary" onClick={()=> this.handleUpdateSubmit({selectedItem})}>
                  Update Transaction
                </Button>
              </Col>
            :
            <Col sm={4} className="pull-right">
              <Button className="button2" bsStyle="primary" onClick={()=> this.handleUpdateSubmit({selectedItem})}>
                Update Transaction
              </Button>
            </Col>
        }
        </Row>
      </div>
    )
  }
}

export default TransactionUpdate
